import { render, staticRenderFns } from "./AccountSubscriptionsDetail.vue?vue&type=template&id=5d880164&"
import script from "./AccountSubscriptionsDetail.vue?vue&type=script&lang=ts&"
export * from "./AccountSubscriptionsDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports